import { ReactElement } from 'react'

import classNames from 'classnames'

import { Segment } from 'api/Cerebro/orgScoped/segments/types'
import { Flex, Icon, Text } from 'components/core'

import * as styles from './styles.module.scss'

type SegmentTypeTagSize = 'small' | 'default'

interface SegmentTypeTagProps {
    segment: Pick<Segment, 'is_variant_level'>
    size?: SegmentTypeTagSize
}

const SegmentTypeText: Record<`vle_${SegmentTypeTagSize}`, string> = {
    vle_small: 'Variants',
    vle_default: 'Variant Estimates',
}

function SegmentTypeTag({
    segment,
    size = 'default',
}: SegmentTypeTagProps): ReactElement | null {
    const text = segment.is_variant_level ? SegmentTypeText[`vle_${size}`] : ''

    return text ? (
        <Flex
            gap={4}
            alignItems="center"
            className={classNames(
                styles.root,
                size === 'small' ? styles.rootSmall : styles.rootDefault
            )}
        >
            <Icon name="PACKAGE" color="primary400" />
            <Text variant="bodySm" fontWeight={500}>
                {text}
            </Text>
        </Flex>
    ) : null
}

export default SegmentTypeTag
